import { defineStore } from 'pinia'

export const useOrderStore = defineStore('order', {
    state: () => ({
        decoCount: {},          // { [decoId]: count }
        previewDataUrl: '',
        formAction: 'cart',
        formData: {},
        context: {},
        previewConfig: {},
    }),
    actions: {
        init(data) {
            this.formAction = data.formAction ?? 'cart'
            this.formData = data.formData ?? {}
            this.context = data.context ?? {}
            this.previewConfig = data.previewConfig ?? {}
        },
        incrementDecoCount(decoId) {
            if (!decoId) return
            this.decoCount[decoId] = (this.decoCount[decoId] ?? 0) + 1
        },
        decrementDecoCount(decoId) {
            if (!decoId || !this.decoCount[decoId]) return
            this.decoCount[decoId]--
            if (this.decoCount[decoId] <= 0) delete this.decoCount[decoId]
        },
        setPreviewDataUrl(url) {
            this.previewDataUrl = url
        },
        decoCountAsArray() {
            return Object.entries(this.decoCount).map(([id, count]) => [id, count])
        },
    },
})
